import { Button, ButtonVariant, Spinner } from "@swivl-mono/ui";
import { nanoid } from "nanoid";
import { useEffect, useState } from "react";
import { AIModel } from "../../../Models/AI/AI.Model";
import { Member } from "../../../Models/Member/Member.Current";
import "./AIAssistSettings.scss";
import { CustomPrompt } from "./Components/CustomPrompt";

export default function AIAssistSettingsView() {
  const [isCreating, setIsCreating] = useState<boolean>(false)

  const { prompts } = AIModel.useState()
  useEffect(() => {
    AIModel.loadPrompts()
  }, [])

  if (!prompts) return (<div className="AIAssistSettings"><Spinner /></div>)

  return (
    <div className="AIAssistSettings">
      {/* 
      <label>Auto Complete Prompt</label>
      <textarea value={fields.autoCompletePrompt} name="autoCompletePrompt" onChange={onChange} onBlur={onBlur}></textarea>


      <label>Conversation Summary Prompt</label>
      <textarea value={fields.summarizePrompt} name="summarizePrompt" onChange={onChange} onBlur={onBlur}></textarea>

      <label>Review Reply Prompt</label>
      <textarea value={fields.reviewReplyPrompt} name="reviewReplyPrompt" onChange={onChange} onBlur={onBlur}></textarea>

      <label>Custom Prompts
      </label> */}
      {!prompts && <Spinner />}
      {prompts?.map((prompt) => <CustomPrompt key={(prompt as any).id} prompt={prompt} />)}

      <Button
        variant={ButtonVariant.DASHED}
        loading={isCreating}
        onClick={async () => {
          setIsCreating(true)
          await AIModel.savePrompt({ name: "New Prompt", text: "", orgId: Member.orgId, slug: nanoid(8) })
          setIsCreating(false)
        }}
      >
        Create Prompt
      </Button>
    </div>
  );
}
